import { Meteor } from 'meteor/meteor';
import React from 'react';
import Moment from 'react-moment';
import { Link } from 'react-router';

import {
  Button,
} from '@sketchpixy/rubix';

export default class ReservationComponent extends React.Component {
	constructor(props) {
		super(props);
	}

  goToView() {
    this.context.router.push('/reservations/' + this.props.reservation._id);
  }

  renderBillState() {
    if(this.props.reservation.state < 3)
      return (<Button bsStyle="danger">{this.props.reservation.getSolde()}€</Button>);
    else
      return (<Button bsStyle="success">{this.props.reservation.getSolde()}€</Button>);
  }

  renderBilletState() {
	  	if(this.props.reservation.impression && this.props.reservation.state < 5)
	  		return (<Button bsStyle="danger">Mail</Button>)


	  	if(this.props.reservation.state < 5)
	  		return (<Button bsStyle="danger">Courrier</Button>);
	  	else {
	  		if(this.props.reservation.impression)
	  			return (<Button bsStyle="success">Mail</Button>)
	  		else
	  			return (<Button bsStyle="success">Courrier</Button>)
	  	}
  }

	render() {
      return (
          <tr>
            <td>{this.props.reservation.id}</td>
            <td>{this.props.reservation.id_billet} {!this.props.reservation.id_billet && <span>-</span>}</td>
            <td>{this.props.reservation.searchName}</td>
            <td>{this.props.reservation.getAuthor()}</td>
            <td>{this.props.reservation.getState()}</td>
            <td>{this.props.reservation.getPrice()}€</td>
            <td><Moment format="DD/MM/YYYY à kk:mm">{this.props.reservation.createdAt}</Moment></td>
            {!_.includes(Meteor.user().roles, 'partner') &&
            	<td>
            	  {this.renderBillState()}
            	</td>
            }
            <td>
            	{this.renderBilletState()}
            </td>
            <td>
				<Link to={"/reservations/" + this.props.reservation._id} key={this.props.reservation._id}>
                	<Button bsStyle="primary" onClick={this.goToView.bind(this)}>Ouvrir</Button>&nbsp;&nbsp;
                </Link>
            </td>
          </tr>
      );
	}
}

ReservationComponent.propTypes = {
  reservation: React.PropTypes.object.isRequired,
};

ReservationComponent.contextTypes = {
  router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/reservations/components/component-reservations-list.js
 **/